<template>
  <BaseButton :variant="variant" @click="$emit('click')">
    <BaseIcon v-if="isShowIcon" icon-name="download" :width="iconWidth" :height="iconHeight">
      <IconDownload></IconDownload>
    </BaseIcon>
    <slot></slot>
  </BaseButton>
</template>

<script>
import buttonMixin from '@/mixins/button';
import BaseIcon from '@/components/BaseIcon.vue';
import IconDownload from '@/components/icon/IconDownload.vue';

export default {
  mixins: [buttonMixin],
  components: {
    BaseIcon,
    IconDownload,
  },
  props: {
    variant: { type: String, default: 'outline-secondary' },
  },
};
</script>

<style lang="scss" scoped></style>
